import { appConfig } from '@/config/app-config';
import {
  BookingFormData,
  BookingSlot,
  OnlineBookingBaseConfig,
  OnlineBookingResponse,
  ResourceListItemDTO,
} from '@bookings/interfaces/online-bookings';

/* eslint-disable @typescript-eslint/no-explicit-any */
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import BPCApiServiceInstance from '@core/services/bpc-api-service.instance';

export default class OnlineBookingService {
  constructor(
    protected $routeHelper: BPCApiRouteHelper,
    protected $bpcApi: BPCApiServiceInstance,
  ) {}

  public async getOnlineBookingBaseConfig(contactId: number): Promise<OnlineBookingBaseConfig> {
    // FIXME change the endpoint name
    const path = this.$routeHelper.getApiPath(`online-bookings/base-config`);
    const params = { contactId };
    const response = await this.$bpcApi.get(path, { params }).toPromise();
    return response.data as OnlineBookingBaseConfig;
  }

  public async getAvailableSlots(
    disciplineId: number,
    contactId: number,
    date: string,
    slotDuration: string,
  ): Promise<BookingSlot[]> {
    const path = this.$routeHelper.getApiPath(`online-bookings/available-slots`);
    const params = { disciplineId, contactId, date, slotDuration };
    const response = await this.$bpcApi.get(path, { params }).toPromise();
    return response.data as BookingSlot[];
  }

  public async getAvailableResources(
    disciplineId: number,
    contactId: number,
    date: string,
    slotDuration: string,
    startTime: string,
    resourceIds: number[],
  ): Promise<ResourceListItemDTO[]> {
    const path = this.$routeHelper.getApiPath(`online-bookings/available-resources`);
    const params = {
      disciplineId,
      contactId,
      date,
      slotDuration,
      startTime,
      resourceIds,
    };
    const response = await this.$bpcApi.get(path, { params }).toPromise();
    return response.data as ResourceListItemDTO[];
  }

  public async addBooking(formModel: BookingFormData): Promise<OnlineBookingResponse> {
    const path = this.$routeHelper.getApiPath(`online-bookings`);
    const response = await this.$bpcApi.post(path, formModel).toPromise();
    return response.data as OnlineBookingResponse;
  }
}

export const useOnlineBookingService = (): OnlineBookingService => {
  return new OnlineBookingService(
    new BPCApiRouteHelper(),
    new BPCApiServiceInstance({ apiPath: appConfig.apiPathV2 }),
  );
};
